import React, { useState, useEffect } from 'react'
import { FormControl, makeStyles, MenuItem, Select } from '@material-ui/core'
import { useQuery, useQueryClient } from 'react-query'
import selectOrgStyles from './selectOrg.styles'
import ExpandIcon from '../../assets/icons/expandIcon'
import SelectRenderValue from '../SelectRenderValue/SelectRenderValue'
import QueryKeys from '../../utils/constants/queryKeys'
import getOrgs from '../../Apis/organisation/getOrgs'
import useQueryParams from '../../hooks/useQueryParams'
import useHistoryPush from '../../hooks/useHistoryPush'
import redirectToHomeHelper from '../../utils/helpers/redirectToHomeHelper'
import localStorageIds from '../../utils/constants/localStorageIds'
import storableOrg from '../../utils/helpers/storableOrg'
import sortArrayOfObjectsByName from '../../utils/helpers/sortArrayOfObjectsByName'
import useGetLocalStorage from '../../hooks/useGetLocalStorage'
import {
  setLocalStorageValue,
  removeLocalStorageValue,
} from '../../utils/helpers/localStorageHelperMethods'

const SelectOrg = () => {
  const [org, setOrg] = useState('')
  const [orgs, setOrgs] = useState('')
  const queryParams = useQueryParams()
  const queryClient = useQueryClient()
  const { redirect } = useHistoryPush()
  const localStorageValue = useGetLocalStorage()
  const { [localStorageIds.SELECTED_ORG]: selectedOrg } = localStorageValue || {}
  const useStyles = makeStyles(selectOrgStyles)
  const classes = useStyles()

  useEffect(() => {
    if (selectedOrg?.id !== org?.id) {
      setOrg(selectedOrg)
    }
  }, [selectedOrg])

  const allOrgs = useQuery([QueryKeys.GET_ORGS], () => getOrgs())

  // Derived via effect rather than onSuccess, which doesn't run when a mount
  // is served from fresh cache and would leave the selector unrendered.
  useEffect(() => {
    const fetchedOrgs = allOrgs.data
    if (!fetchedOrgs) return
    const oldUrlOrgId = queryParams?.org || selectedOrg?.id
    const newOrg = fetchedOrgs?.find((c) => c.id === oldUrlOrgId)
    setOrgs(fetchedOrgs)
    setOrg(newOrg ?? (fetchedOrgs?.length ? fetchedOrgs[0] : undefined))
  }, [allOrgs.data])

  const handleChange = (e) => {
    if (orgs && orgs.length) {
      orgs.map((c) => {
        if (c.id === e.target.value.id) {
          const { teams } = c || {}

          setOrg(c)
          setLocalStorageValue([{ id: localStorageIds.SELECTED_ORG, value: storableOrg(c) }])
          queryClient.invalidateQueries(QueryKeys.GET_TEAMS)

          removeLocalStorageValue([localStorageIds.SELECTED_SEASON, localStorageIds.SELECTED_COMPETITION, localStorageIds.SELECTED_STAGE, localStorageIds.SELECTED_GROUP])

          return redirectToHomeHelper(teams, redirect, c)
        }

        return null
      })
    }
  }

  const handleOpen = () => {
    allOrgs.refetch()
  }

  const orderedOrgs = orgs
    ? sortArrayOfObjectsByName(
        orgs.filter((cb) => cb?.id !== org?.id),
        'name',
        'DESC',
      )
    : []
  if (org) orderedOrgs?.unshift(org)

  if (!orgs || !orgs.length) return null

  return (
    <FormControl variant='filled'>
      <Select
        classes={{ select: classes.select, filled: classes.selectInput }}
        disableUnderline
        IconComponent={ExpandIcon}
        name='selectOrg'
        value={org}
        onChange={handleChange}
        onOpen={handleOpen}
        renderValue={(item) => (
          <SelectRenderValue item={item} chosenOption={org} logoArgName='logoUrl' labelBlack />
        )}
        style={{
          height: '40px',
          backgroundColor: '#f5f5f5',
          width: '200px',
          borderRadius: '5px',
        }}
      >
        {orderedOrgs?.map((item) => (
          <MenuItem
            key={item?.id}
            value={item}
            classes={{
              root: classes.menuItemRoot,
              selected: classes.menuItemSelected,
            }}
          >
            <SelectRenderValue item={item} logoArgName='logoUrl' chosenOption={org} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
export default SelectOrg
